import BindSubcategories from "../symbols/bindSubcategories";
import { HttpRequestPut } from "../../service";
const bindSubcategoriesAction = () => ({
  type: BindSubcategories.BIND_SUBCATEGORIES,
});
const bindSubcategoriesSuccessAction = (data: any) => ({
  type: BindSubcategories.BIND_SUBCATEGORIES_SUCCESS,
  payload: data,
});
const bindSubcategoriesFailureAction = (data: any) => ({
  type: BindSubcategories.BIND_SUBCATEGORIES_FAILURE,
  payload: data,
});
const clearBindSubcategoriesAction = () => ({
  type: BindSubcategories.CLEAR_BIND_SUBCATEGORIES,
});

export function bindSubcategories(
  categoryId: string,
  Subcategories: Array<string>
) {
  return (dispatch: any) => {
    dispatch(bindSubcategoriesAction());
    HttpRequestPut(
      `/upc/category/${categoryId}/bind`,
      dispatch,
      bindSubcategoriesSuccessAction,
      bindSubcategoriesFailureAction,
      true,
      {
        SubCategories: Subcategories,
      }
    );
  };
}

export function clearBindSubcategories() {
  return (dispatch: any) => {
    dispatch(clearBindSubcategoriesAction());
  };
}
